import { defineComponent, watch, onUnmounted } from 'vue';
import ItemDetailBanner from './components/ItemDetailBanner.vue';
import ItemDetailBox from '@/components/ItemDetailBox.vue';
import ItemDetailNavBar from '@/components/ItemDetailNavBar.vue';
import { ItemService } from '@/services/item.service';
import { declareProviders, useService } from '@kaokei/use-vue-service';
import { useRoute, useRouter } from 'vue-router';
import { UserService } from '@/services/user.service';
export default defineComponent({
  name: 'ItemDetail',
  components: {
    ItemDetailBanner: ItemDetailBanner,
    ItemDetailBox: ItemDetailBox,
    ItemDetailNavBar: ItemDetailNavBar
  },
  setup: function () {
    declareProviders([ItemService]);
    var userService = useService(UserService);
    var itemService = useService(ItemService);
    var route = useRoute();
    var router = useRouter();
    var id = +route.params.id;
    var updateContestInfo = function () {
      itemService.getContestDetailInfo(id).catch(function (e) {
        // add sentry mark
        // console.log('setTag', 'api', 'updateContestInfo');
        router.replace({
          name: 'UserItemList'
        });
      });
    };
    onUnmounted(function () {
      itemService.clearTimer();
    });
    watch(function () {
      return userService.user;
    }, function () {
      updateContestInfo();
    }, {
      immediate: true
    });
    return {
      itemService: itemService
    };
  }
});